import { getMemberHost } from "config";
import { ProgramTerms } from "types";
import { authenticatedFetch } from "./authenticatedFetch";

export const fetchActiveProgramTerms = (advertiserId: number): Promise<ProgramTerms[]> =>
  authenticatedFetch<ProgramTerms[]>(`https://${getMemberHost()}/affapi/advertiser/${advertiserId}/programterms`);
